import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import PublicLayout from "@/pages/public/PublicLayout";
import { HorizontalPostSlider, PostReadingDrawer, SubscriberNewsletterSection } from "@/components/posts/PublicPosts";

const SECTIONS = [
  { key: "global", theme: "indigo", title: "Platform Announcements & Global Releases", sub: "Fresh from Ponderr HQ" },
  { key: "school", theme: "blue", title: "Campus Life & School Bulletins", sub: "News from our partner schools" },
  { key: "tv_channel", theme: "red", title: "Ponderr TV & Visual Shows", sub: "Episodes & highlights" },
  { key: "academy", theme: "orange", title: "Evening Academies & Workshops", sub: "Upskill after school" },
  { key: "store", theme: "green", title: "Campus Stores & Book Deals", sub: "Latest arrivals & offers" },
  { key: "community", theme: "teal", title: "MyRezz & Xplore (Career & Skills)", sub: "Olympiads, careers & more" },
];

const PILLS = [["all", "All"], ["global", "Global"], ["school", "Schools"], ["tv_channel", "Ponderr TV"],
  ["academy", "Academies"], ["store", "Bookstores"], ["community", "MyRezz & Xplore"]];

export default function PostsPage() {
  const [buckets, setBuckets] = useState({});
  const [active, setActive] = useState("all");
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/posts/public-feed").then((r) => setBuckets(r.data || {})).catch(() => {}); }, []);
  const shown = useMemo(() => active === "all" ? SECTIONS : SECTIONS.filter((s) => s.key === active), [active]);

  return (
    <PublicLayout>
      <div data-testid="posts-page">
        {/* Hero */}
        <section className="bg-[#1A1030] text-white border-b-2 border-black">
          <div className="max-w-6xl mx-auto px-4 py-14 text-center">
            <h1 className="display text-4xl sm:text-5xl lg:text-6xl font-black" data-testid="posts-hero-title">Explore Ecosystem Stories & Updates</h1>
            <p className="mt-4 max-w-2xl mx-auto text-white/70 text-base md:text-lg">
              Live announcements, campus highlights, TV episodes, course launches, and bookstore arrivals across our learning network.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-2">
              {PILLS.map(([id, label]) => (
                <button key={id} onClick={() => setActive(id)} data-testid={`posts-pill-${id}`}
                  className={`px-4 py-1.5 rounded-full text-sm font-bold border-2 transition-colors ${active === id ? "bg-white text-black border-white" : "border-white/40 text-white/80 hover:bg-white/10"}`}>{label}</button>
              ))}
            </div>
          </div>
        </section>

        {shown.map((s) => (
          <HorizontalPostSlider key={s.key} title={s.title} subtitle={s.sub} themeColor={s.theme}
            posts={buckets[s.key] || []} onOpen={setOpen} />
        ))}

        <SubscriberNewsletterSection />
      </div>
      <PostReadingDrawer post={open} onClose={() => setOpen(null)} />
    </PublicLayout>
  );
}
